import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const fetchSpecificListingApi = createApi({
  reducerPath: "fetchSpecificListingApi",
  baseQuery: fetchBaseQuery({
    baseUrl:
      "https://firestore.googleapis.com/v1/projects/clone-realtor-557bf/databases/(default)/documents"
  }),
  tagTypes: ["allListings"],
  endpoints: (builder) => ({
    getSpecificListing: builder.query({
      query: (id: string) => `/allListings/${id}`,
      providesTags: (result, error, id) => [
        { type: "allListings", id },
        { type: "allListings" }
      ]
    })
  })
});

export const { useGetSpecificListingQuery } = fetchSpecificListingApi;
